export const errorMsg = {
  fs: {
    1: 'File has been completely uploaded',
    15: 'No such file or directory',
    17: 'Upload failed, current Datadrive is full or expired. Please expand your quota or contact our assistant for help.',
    54: 'File already exists',
  },
  [-6]: 'Too many operations, please try again later',
  1: 'Server internal error',
  2: 'Username or password incorrect, please retry', // 'User does not exist'
  3: 'Username or password incorrect, please retry', // 'Password incorrect'
  4: 'Account already registered',
  5: 'Verification code incorrect, please retry',
  6: 'Service exception, please try again later or contact our assistant for help',
  7: 'Insufficient privileges to access',
  8: 'Password does not meet the rules: requires 8-20 characters and no Chinese characters',
  17: 'disk quota exceeded',
  20: 'Machine status exception, please refresh the page and try again.',
  23: 'Verification code sent too frequently, please try again later',
  24: 'Phone number blocked by operator, please contact our assistant for help',
  28: 'Account abnormality, please contact our assistant for help',
  29: 'Image count exceeded',
  39: 'Activity has expired',
  40: 'You have already participated in this activity. Please check the rewards center.',
  41: 'Voucher has been redeemed',
  46: 'Insufficient balance, please recharge and try again',
  47: 'You have already submitted your student verification. Please do not submit again',
  49: 'Your application has been approved',
  51: 'Your privileges are restricted and you cannot access this page',
  53: 'Sorry, there are not enough machines available',
  55: 'You have no operation permission',
  57: 'Sorry, the machine is occupied by another user',
  59: 'New and old passwords cannot be the same. Please modify and try again.',
  78: 'Environment save operation has been completed. You cannot modify or cancel it.',
  79: 'Snapshot has finished already',
  80: 'Edu verify failed',
  82: 'You can only enjoy one student package per month. Welcome to purchase next month.',
  83: 'Inventory is insufficient. If you need help, please contact our assistant.',
  88: 'The number of machines in the current cluster has reached its maximum limit.',
  90: 'Machine status abnormal. Please refresh and try again.',
  94: 'The environment used to start the machine has been deleted. You cannot continue saving it.',
  107: 'The email you entered is already occupied by another account. If you need help, please contact our assistant.',
  111: 'This X account is already linked to another Glows account.',
  114: 'The current system does not support saving an unpublic image as a team environment, and also does not support saving a team environment as a personal environment or other team environment',
  122: 'The information you entered may contain incorrect information. Please modify it and try again. If you have any questions, please contact our assistant.',
  132: 'Snapshot not available. Please choose another snapshot.',
  133: 'The network group name already exists',
  148: 'Environment save failed: The environment depends on the base image of the course or group, which is not available to non-members',
  149: 'The dependent course or group image no longer exists. You cannot save the environment.',
  155: 'Operation failed: The group does not exist',
  156: 'Operation failed. Please remove all machines before deleting a group',
  157: 'Cluster creation failed. Please contact our assistant to check detailed reasons',
  158: 'Cluster upgrade failed. Please contact our assistant to check detailed reasons',
  159: 'Operation failed. Do not repeat the operation in a short time.',
  160: 'Operation failed. Do not repeat the operation in a short time.',
  161: 'Operation failed. The node status is abnormal. Please try again later.',
  164: 'Instance quota insufficient. If you need more, please contact our assistant.',
  167: 'Currently, virtual machines cannot be added to a deep learning cluster',
  170: 'Addition failed. There are unsupported instance types (e.g., instances that support Docker) in the selected instances',
  171: 'The node is currently a package instance. You cannot manually release it.',
  174: 'Image already exists',
  177: 'Lack of resume times',
  184: 'Duplicate scaling rule, please change the rule name',
  186: 'This resource is still in use by other resources. Please remove them before deleting.',
  187: 'The network group does not exist',
  194: 'Port mapping conflict: the public IP port is already in use. Please choose another port.',
  195: 'Team access permission denied, please contact our assistant for help',
  196: 'Cannot create member: This account name is already in use',
  197: 'Storage capacity exceeds your quota. Please contact our assistant for help.',
  198: 'Instance quota exceeded. Please contact our assistant for help.',
  199: 'Snapshot quota exceeded. Please contact our assistant for help.',
  200: 'This team account has already been linked to another platform account',
  201: 'You have already joined this team',
  202: 'Team member limit reached. Please upgrade your plan or contact our assistant.',
  203: 'Team admin limit reached. Please upgrade your plan or contact our assistant.',
  204: 'Cannot delete member: This member has active instances. Please stop all instances first.',
  205: 'Cannot delete member: This member has active snapshots. Please delete all snapshots first.',
  209: 'Machine image does not match',
  210: 'Free plan team limit reached. Please upgrade your plan to create more teams.',
  211: 'This team is inactive. Please contact your team administrator or our assistant for help.',
  212: 'Auto deployment quota exceeded. Please contact our assistant for help.',
  213: 'Auto scaling quota exceeded. Please contact our assistant for help.',
  214: 'Quota exceeded the upper limit',
  215: 'No resource available',
  216: 'Machine specification does not match the selected item',
  217: 'Insufficient CPU resource',
  218: 'Insufficient RAM resource',
  219: 'Insufficient disk resource',
  220: 'Insufficient GPU resource',
  221: 'Invalid API credential',
  222: 'Image format not supported',
  234: 'Could not reach the registry',
  223: 'ACL resource already exists',
  224: 'ACL resource does not exist',
  225: 'An L3 rule with the same Source IP already exists. Please change the Source IP or edit the existing rule.',
  226: 'ACL version mismatch. Please refresh and try again.',
  227: 'Default policy can only be changed when no L4 exception rule is attached.',
  228: 'Duplicate image visibility update',
  229: 'ACL rule limit exceeded',
  230: 'Unsupported extra resource type',
  231: 'Insufficient extra CPU resource',
  232: 'Insufficient extra RAM resource',
  233: 'Insufficient extra disk resource',
  235: 'Verification code incorrect, please try again',
  236: 'MFA configuration does not exist',
  237: 'MFA is already enabled',
  238: 'MFA is not enabled',
  239: 'Recovery code is invalid or has already been used',
  240: 'MFA verification has expired, please log in again',
  241: 'No extra resource available',
  // Canvas (Model Route) codes — same code ledger as the platform
  243: 'Project not found',
  244: 'Workflow not found',
  245: 'Workflow version not found',
  246: 'Workflow execution not found',
  247: 'Route not found',
  248: 'Model not found',
  249: 'Model route limit exceeded. Please contact our assistant for help.',
}

// Error codes to ignore for specific sources
// Platform source: 1 = Server internal error (handled elsewhere), 80 = Edu verify failed, 194 = Conflict port mapping
// fs source: Should NOT ignore code 1 as it means "File has been completely uploaded" and should be shown
export const ignoreErrorCodes: Record<string, number[]> = {
  platform: [1, 80, 194],
}
